import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from '../services/logger.service';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private apiUrl = environment.api_service_users;
    private userSubject: BehaviorSubject<any>;
    user$: Observable<any>; // Tipado estricto

    constructor(private http: HttpClient, private logger: LoggerService) {
        const storedUser = sessionStorage.getItem('currentUser');
        const initialValue = storedUser ? JSON.parse(storedUser) : null;
        this.userSubject = new BehaviorSubject<any>(initialValue);

        this.user$ = this.userSubject.asObservable();
        this.userSubject.next(initialValue);
    }

    updateUser(user: any): void {
        this.logger.log("UserService.updateUser");
        if (!user) {
            const userJson = sessionStorage.getItem('currentUser');
            if (userJson) {
                const userObj = JSON.parse(userJson);
                this.http.get<any>(`${environment.api_service_users}/${userObj.id}`).subscribe(
                    (data: any) => {
                        user = data;
                        sessionStorage.setItem('currentUser', JSON.stringify(user));
                        this.userSubject.next(user);
                    },
                    (error: any) => { this.logger.error('Error loading estimation: ', error); }
                );
            }
        }
    }

    getCurrentUser(): any { return this.userSubject.getValue(); }

    // --- NUEVOS MÉTODOS CRUD (Gestión de Usuarios) ---
    getAllUsers(): Observable<any[]> {
        return this.http.get<any[]>(this.apiUrl);
    }

    getUserById(id: string): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/${id}`);
    }

    createUser(user: any): Observable<any> {
        return this.http.post<any>(this.apiUrl, user);
    }

    updateUserById(id: string, user: any): Observable<any> {
        return this.http.put<any>(`${this.apiUrl}/${id}`, user);
    }

    // NUEVO: Método específico para la Máquina de Estados
    updateUserStatus(id: string, estado: string): Observable<any> {
        return this.http.put<any>(`${this.apiUrl}/${id}/status`, { estado });
    }

    deleteUser(id: string): Observable<any> {
        return this.http.delete<any>(`${this.apiUrl}/${id}`);
    }

    // --- NUEVO: Métodos de Mi Perfil ---
    getMyProfile(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/me/profile`);
    }

    updateMyProfile(data: any): Observable<any> {
        return this.http.put<any>(`${this.apiUrl}/me/profile`, data);
    }

    changeMyPassword(data: any): Observable<any> {
        return this.http.put<any>(`${this.apiUrl}/me/password`, data);
    }
}